import React, { ReactNode } from "react";

import { faCheck } from "@fortawesome/pro-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";

import { isDefined } from "@mapmycustomers/shared/util/assert";

const block = bem("mmc-selectable-item");

interface SelectableItemProps {
  className?: string;
  label: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  selectedClassName?: string;
  tooltip?: ReactNode;
}

const SelectableItem = ({
  className,
  label,
  onClick,
  selected,
  selectedClassName,
  tooltip,
}: SelectableItemProps) => {
  return (
    <div
      className={cn(block({ selected }), className, {
        ...(selectedClassName ? { [selectedClassName]: selected } : {}),
      })}
      onClick={onClick}
    >
      <div className={block("label")}>
        <Tooltip mouseEnterDelay={1} title={isDefined(tooltip) ? tooltip : label}>
          {label}
        </Tooltip>
      </div>
      <div className={block("icon")}>{selected && <FontAwesomeIcon icon={faCheck} />}</div>
    </div>
  );
};

export default SelectableItem;
